import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LogoIcon from "../assets/Images/New_logo copy.png";
import LogoText from "../assets/Images/New_logo.png";
// import { styled, Box } from '@mui/system';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Menu, MenuItem, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import DialogBox from "../../src/Components/common/dialog";
import { Logout } from "../assets/icons";
import "../assets/scss/navbar.scss";
import instance from "../redux/api";
import ROUTES from "../utils/routes";
import ChangePassword from "./ChangePassword";
import { loginMethods } from "../Components/CashAllocation/constants";
import { logout, setIsLoggedIn } from "../redux/slice/loginSlice";
import { CustomLoader } from "./CustomLoader";
import { masterData } from "./MasterData";
import { getAllReportsLinks } from "../redux/slice/ReportsSlice";
import NotificationBell from "./Notifications/NotificationBell";

export default function Navbar() {
  // Selectors
  const { userData } = useSelector((state) => state?.user);
  const { reportSidebarData, isLoading: isReportsLoading } = useSelector((state) => state?.allReportsDetails);
  // After browser relaod it's making to false (handle with redux persist // Todo)
  // const { isLoggedIn } = useSelector((state) => state?.login);

  const { isLoggedIn, loginError, isLoading } = useSelector((state) => state?.login);

  // Hooks
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Local State
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [creditControlAnchorEl, setCreditControlAnchorEl] = useState(null);
  const [bdxAnchorEl, setBdxAnchorEl] = useState(null);
  const [treasuryAnchorEl, setTreasuryAnchorEl] = useState(null);
  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  const [administrationAnchorEl, setAdministrationAnchorEl] = useState(null);
  const [isLogoutConfirmationDialog, setIsLogoutConfirmationDialog] =
    useState(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    setIsLogoutConfirmationDialog(true);
  };

  const handleLogoutConfirmation = async () => {
    // const loginMethod = Cookies.get("loginMethod", "");
    // if(loginMethod === loginMethods.oauth) {
    //   try {
    //     await instance.post(
    //       "users/oauth_logout/", {}
    //     );
    //   } catch (error) {
    //     console.log("Error Over Invalidating Token : ", error);
    //   }
    // }

    // localStorage.clear();
    // Cookies.remove("accessToken");
    // Cookies.remove("refreshToken");
    // Cookies.remove("isLoggedIn");
    // Cookies.remove("loginMethod");
    // navigate("/");

    dispatch(logout()).then(() => {
      setIsLogoutConfirmationDialog(false);
    }).catch((err) => {
      console.error("Logout failed", err);
    });
  };

  const handleLogoutCancelled = () => {
    setIsLogoutConfirmationDialog(false);
  };

  const handleResetPassword = () => {
    setAnchorEl(null);
    setOpen(true);
  };

  const handleCreditControlMenuClick = (event) => {
    setCreditControlAnchorEl(event.currentTarget);
  };

  const handleCreditControlMenuClose = () => {
    setCreditControlAnchorEl(null);
  };

  const handleCreditControlMenuItemClick = (path) => {
    navigate(path);
    handleCreditControlMenuClose();
  };

  // BDX Dropdown Handlers
  const handleBdxMenuClick = (event) => {
    setBdxAnchorEl(event.currentTarget);
  };

  const handleBdxMenuClose = () => {
    setBdxAnchorEl(null);
  };

  const handleBdxMenuItemClick = (path) => {
    navigate(path);
    handleBdxMenuClose();
  };

  // Treasury Dropdown Handlers
  const handleTreasuryMenuClick = (event) => {
    setTreasuryAnchorEl(event.currentTarget);
  };

  const handleTreasuryMenuClose = () => {
    setTreasuryAnchorEl(null);
  };

  const handleTreasuryMenuItemClick = (path) => {
    navigate(path);
    handleTreasuryMenuClose();
  };

  // report menu handler
  const handleReportMenuClick = (event) => {
    setReportAnchorEl(event.currentTarget);
  };

  const handleReportMenuClose = () => {
    setReportAnchorEl(null);
  };

  const handleReportMenuItemClick = (path) => {
    console.log('path', path)
    navigate(path);
    handleReportMenuClose();
  };

  // Administration Dropdown Handlers
  const handleAdministrationMenuClick = (event) => {
    setAdministrationAnchorEl(event.currentTarget);
  };

  const handleAdministrationMenuClose = () => {
    setAdministrationAnchorEl(null);
  };

  const handleAdministrationMenuItemClick = (path) => {
    navigate(path);
    handleAdministrationMenuClose();
  };

  // Filter menu items based on user role
  const getFilteredItems = (section) => {
    if (!userData?.role || !masterData[section]) return [];
    const userRole = userData.role.toLowerCase();
    return masterData[section].filter((item) =>
      item.rolesCanAccess.some((role) => role.toLowerCase() === userRole)
    );
  };

  const getFilteredCreditControlItems = () => getFilteredItems("Credit-Control");
  const getFilteredBdxItems = () => getFilteredItems("BDX");
  const getFilteredTreasuryItems = () => getFilteredItems("Treasury");
  const getFilteredReportItems = () => {
    if (!reportSidebarData || reportSidebarData.length === 0) return [];
    if (!userData?.role) return [];
    const userRole = userData.role.toLowerCase();

    return reportSidebarData.filter((item) =>
      item.rolesCanAccess?.some((role) => role.toLowerCase() === userRole)
    );
  };
  const getFilteredAdministrationItems = () => getFilteredItems("Administration");

  const isActive = (path) => {
    return location.pathname.toLowerCase().startsWith(path.toLowerCase());
  };

  const reloadPage = () => window.location.reload();

  // Fetch All Reports Links
  useEffect(() => {
    dispatch(getAllReportsLinks());
  }, []);

  return isLoggedIn ? (
    <>
      <div className="navbar">
        <a
          href="/Credit-Control/Upload-files"
          onClick={reloadPage}
          style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "3px", marginLeft: "30px" }}
        >
          <img
            src={LogoIcon}
            alt="InsurPremMgmt Icon"
            style={{
              height: "50px",
              width: "auto",
              objectFit: "contain",
              filter: "brightness(1.3)"
            }}
          />
          <img
            src={LogoText}
            alt="InsurPremMgmt Text"
            style={{
              height: "50px",
              width: "auto",
              objectFit: "contain",
              filter: "brightness(0) invert(1)"
            }}
          />
        </a>
        {!(
          location.pathname === "/" ||
          location.pathname === "/forget-password"
        ) && (
            <>
              <div className="navBarContainer">
                <NavLink
                  to={ROUTES.Dashboard}
                  className={`navLink ${isActive("/Dashboard") ? "activeLinkStyle" : ""
                    }`}
                >
                  Dashboard
                </NavLink>
                <div
                  onClick={handleCreditControlMenuClick}
                  className={`navLink creditControlDropdown ${isActive("/Credit-Control") ? "activeLinkStyle" : ""
                    }`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span>Credit Control</span>
                  <ArrowDropDownIcon style={{ fontSize: "18px", display: "inline-flex", verticalAlign: "middle" }} />
                </div>

                {/* <NavLink
                  to="/cash-processing"
                  className={`navLink ${location.pathname === "/cash-processing"
                    ? "activeLinkStyle"
                    : ""
                    }`}
                >
                  Reconciliation
                </NavLink> */}
                {/* <NavLink
                to="/bdx"
                className={`navLink ${
                  location.pathname === "/bdx" ? "activeLinkStyle" : ""
                }`}
              >
                BDX
              </NavLink> */}

                <div
                  onClick={handleBdxMenuClick}
                  className={`navLink bdxDropdown ${isActive("/bdx") ? "activeLinkStyle" : ""
                    }`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span>BDX</span>
                  <ArrowDropDownIcon style={{ fontSize: "18px", display: "inline-flex", verticalAlign: "middle" }} />
                </div>

                <div
                  onClick={handleTreasuryMenuClick}
                  className={`navLink treasuryDropdown ${isActive("/Treasury") ? "activeLinkStyle" : ""
                    }`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span>Treasury</span>
                  <ArrowDropDownIcon style={{ fontSize: "18px", display: "inline-flex", verticalAlign: "middle" }} />
                </div>
                <div
                  onClick={handleReportMenuClick}
                  className={`navLink reportDropdown ${isActive("/Reports") ? "activeLinkStyle" : ""
                    }`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span>Reports</span>
                  <ArrowDropDownIcon style={{ fontSize: "18px", display: "inline-flex", verticalAlign: "middle" }} />
                </div>
                <div
                  onClick={handleAdministrationMenuClick}
                  className={`navLink administrationDropdown ${isActive("/administration") ? "activeLinkStyle" : ""
                    }`}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <span>Administration</span>
                  <ArrowDropDownIcon style={{ fontSize: "18px", display: "inline-flex", verticalAlign: "middle" }} />
                </div>
              </div>

              <div className="navBarRightContainer">
                <div className="notification">
                  <NotificationBell/>
                </div>
                <div className="curvedMenuButton" onClick={handleMenuClick}>
                  <Avatar className="userIcon">
                    {userData?.user_name?.charAt(0)}
                  </Avatar>
                  <Typography variant="body1" className="userName">
                    {userData?.user_name ?? ""}
                  </Typography>
                  <IconButton>
                    <ArrowDropDownIcon className="WhiteArrowDropDownIcon" />
                  </IconButton>
                </div>

                <div className="logoutButton" onClick={handleLogout}>
                  <IconButton>
                    <Logout />
                  </IconButton>
                </div>
              </div>
            </>
          )}
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleResetPassword}>Change Password</MenuItem>
      </Menu>

      <Menu
        anchorEl={creditControlAnchorEl}
        open={Boolean(creditControlAnchorEl)}
        onClose={handleCreditControlMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 250,
            maxHeight: 400,
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(22, 114, 222, 0.15)',
            border: '1px solid rgba(22, 114, 222, 0.1)',
            borderRadius: '8px',
            '& .MuiMenuItem-root': {
              padding: '10px 16px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(22, 114, 222, 0.1)',
                color: '#1672DE',
              },
            },
          },
        }}
      >
        {getFilteredCreditControlItems().map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => handleCreditControlMenuItemClick(item.path)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>

      {/* BDX Dropdown Menu */}
      <Menu
        anchorEl={bdxAnchorEl}
        open={Boolean(bdxAnchorEl)}
        onClose={handleBdxMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 250,
            boxShadow: '0 4px 20px rgba(22, 114, 222, 0.15)',
            border: '1px solid rgba(22, 114, 222, 0.1)',
            borderRadius: '8px',
            '& .MuiMenuItem-root': {
              padding: '10px 16px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(22, 114, 222, 0.1)',
                color: '#1672DE',
              },
            },
          },
        }}
      >
        {getFilteredBdxItems().map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => handleBdxMenuItemClick(item.path)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>

      {/* Treasury Dropdown Menu */}
      <Menu
        anchorEl={treasuryAnchorEl}
        open={Boolean(treasuryAnchorEl)}
        onClose={handleTreasuryMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 250,
            boxShadow: '0 4px 20px rgba(22, 114, 222, 0.15)',
            border: '1px solid rgba(22, 114, 222, 0.1)',
            borderRadius: '8px',
            '& .MuiMenuItem-root': {
              padding: '10px 16px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(22, 114, 222, 0.1)',
                color: '#1672DE',
              },
            },
          },
        }}
      >
        {getFilteredTreasuryItems().map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => handleTreasuryMenuItemClick(item.path)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
      <Menu
        anchorEl={reportAnchorEl}
        open={Boolean(reportAnchorEl)}
        onClose={handleReportMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 250,
            maxHeight: 400,
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(22, 114, 222, 0.15)',
            border: '1px solid rgba(22, 114, 222, 0.1)',
            borderRadius: '8px',
            '& .MuiMenuItem-root': {
              padding: '10px 16px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(22, 114, 222, 0.1)',
                color: '#1672DE',
              },
            },
          },
        }}
      >
        {isReportsLoading ? (
          <MenuItem disabled>Loading reports...</MenuItem>
        ) : getFilteredReportItems().length > 0 ? (
          getFilteredReportItems().map((item) => (
            <MenuItem
              key={item.id}
              onClick={() => handleReportMenuItemClick(item.path)}
            >
              {item.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No reports found</MenuItem>
        )}
      </Menu>
      {/* Administration Dropdown Menu */}
      <Menu
        anchorEl={administrationAnchorEl}
        open={Boolean(administrationAnchorEl)}
        onClose={handleAdministrationMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 250,
            maxHeight: 400,
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(22, 114, 222, 0.15)',
            border: '1px solid rgba(22, 114, 222, 0.1)',
            borderRadius: '8px',
            '& .MuiMenuItem-root': {
              padding: '10px 16px',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(22, 114, 222, 0.1)',
                color: '#1672DE',
              },
            },
          },
        }}
      >
        {getFilteredAdministrationItems().map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => handleAdministrationMenuItemClick(item.path)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>

      {open && <ChangePassword setOpen={setOpen} />}

      {isLogoutConfirmationDialog && (
        <DialogBox
          loading={isLoading}
          title="Logout"
          body="Do you want to Logout?"
          confirmText="Logout"
          isOpen={isLogoutConfirmationDialog}
          onCancel={handleLogoutCancelled}
          onConfirm={handleLogoutConfirmation}
        />
      )}

    </>
  ) : (
    <div className="navbar">
      <a
        href="/Credit-Control/Upload-files"
        onClick={reloadPage}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "3px", marginLeft: "100px" }}
      >
        <img
          src={LogoIcon}
          alt="InsurPremMgmt Icon"
          style={{
            height: "50px",
            width: "auto",
            objectFit: "contain",
            filter: "brightness(1.3)"
          }}
        />
        <img
          src={LogoText}
          alt="InsurPremMgmt Text"
          style={{
            height: "50px",
            width: "auto",
            objectFit: "contain",
            filter: "brightness(0) invert(1)"
          }}
        />
      </a>
    </div>
  );
}
